import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AppTable from '../../common/AppTable/AppTable';
import ExportCsvBtn from '../../common/AppSpecificConpnents/ExportCsvBtn';
import { scrollToTop } from '../../util/AppUtils';
import { fetchUsers } from '../../redux/userSlice';
import { showSnackbar } from '../../redux/snackbarSlice';
import { createTask, fetchtAllTasks, exportCSV, setNewTask as setNewTaskAction } from '../../redux/taskSlice';
import AddEditRow from './AddEditRow';
import AddBtn from '../../common/AppSpecificConpnents/AddBtn';
import { canAddTaskOnCurrentScreen, validateTaskInfo, handleUpdateTask, handleDeleteTask, isTerminalTaskStatus, isRevisionPage } from './Uitlities';
import TaskCustomFilter from './TaskCustomFilter';
import { getLoggedInUserInfo } from '../../util/AppUtils';
import Loader from '../../common/Loader';
import { taskTableColumns } from './TaskTableColumns';
import TaskUpdateConfirm from './Popups/TaskUpdateConfirm';

const TaskTable = ({
    closePopup,
    useTableInAuditTrail = false,
    auditTrailRow,
}) => {

    const { tasks, taskInfo, pagination, taskReference, loading, action_item_id, newTask } = useSelector(state => state.task)
    const { users } = useSelector(state => state.users)
    const { task_reference, task_reference_id, task_tree_node_id_ref, procedure_ltree_ref, is_revision } = taskReference || {};
    const canAddTask = canAddTaskOnCurrentScreen();
    const isRevision = isRevisionPage();
    const reassign_persmision = getLoggedInUserInfo()?.permission_to_edit?.Reassign === true;
    // Common
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const tableContainerRef = useRef();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [filterType, setFilterType] = useState("all");

    const columns = taskTableColumns;
    const dispatch = useDispatch();
    //   const { parts, pagination } = useSelector((state) => state.parts);

    useEffect(() => {
        if(isRevision){
            setFilterType("on_this_page");
        }else if(canAddTask){
            setFilterType("for_selection");
        }else{
            setFilterType("all");
        }
    }, [canAddTask,isRevision])
    useEffect(() => {
        if (!useTableInAuditTrail)
            if (searchQuery.length) { //Add this condition to avoide unnecesory initial calls
                let query = searchQuery;
                if (filterType === "assigned_or_owned") {
                    query += `&owned_by_assignee=${localStorage.getItem("user_id")}`;
                } else if (filterType === "on_this_page") {
                    query += `&procedure_ltree_ref=${procedure_ltree_ref}`;
                } else if (filterType === "for_selection" || filterType === "open_tasks") {
                    if(is_revision){
                        if(filterType === "for_selection"){
                            query += `&procedure_ltree_ref=${procedure_ltree_ref}`;
                        }else{
                            query += `&procedure_ltree_ref_with_open=${procedure_ltree_ref}`;
                        }
                    }else{
                        // To handle null and uuid error in the query passing user_id  as reference
                        let qry = `${task_reference_id !== null ? task_reference_id : localStorage.getItem("user_id") }`
                        if(filterType === "for_selection"){
                            query += `&reference=${qry}`;
                        }else{
                            query += `&reference_with_open=${qry}`;
                        }
                    }
                }
                localStorage.taskTableSearchQuery = query;
                dispatch(fetchtAllTasks({ searchQuery: query, action_item_id: action_item_id }));
            }
    }, [dispatch, searchQuery, filterType, taskInfo, task_reference_id, useTableInAuditTrail]);
    // End Common

    const [selected, setSelected] = useState("all")

    const handleSetNewTask = (value) => {
        if (typeof value === 'function') {
            dispatch(setNewTaskAction(value(newTask)));
        } else {
            dispatch(setNewTaskAction(value));
        }
    }

    const [editTask, setEditTask] = useState(null)
    const [previusTaskInfo, setPreviusTaskInfo] = useState(null)
    const [pendingConfirm, setPendingConfirm] = useState(null); // { action: fn, status: string }

    useEffect(() => {
        dispatch(fetchUsers({ limit: 100000, offset: 0 }))
    }, [dispatch])

    const snackbar = (message, type) => {
        dispatch(showSnackbar({ type: type, message: message }))
    }

    const validateTask = (curtskinfo) => validateTaskInfo(curtskinfo, snackbar);

    const validNumber = (number) =>{
        if(number === "" || number === null || number === undefined){
            return 0;
        }else{
            return number
        }
    }

    const proceedWithSave = async () => {
        const currentUserId = localStorage.getItem("user_id");
        const taskinfo = {
            ...newTask,
            reference: task_reference_id,
            tree_node_id_ref: task_tree_node_id_ref,
            created_on: new Date().toISOString(),
            owned_by: newTask.owned_by || currentUserId,
            remind: validNumber(newTask.remind),
            escalate: validNumber(newTask.escalate),
            progress: validNumber(newTask.progress),
            due: newTask.due?.length === 0 ? null : newTask.due,

        }
        
        await dispatch(createTask(taskinfo)).then(async (resp) => {
            if (resp.payload.success === false) {
                snackbar(resp.payload.error, "error");
                return;
            } else {
                snackbar(resp.payload.message, "success");
                await dispatch(fetchtAllTasks({ searchQuery: localStorage.taskTableSearchQuery }));
                handleSetNewTask(null);
                setPendingConfirm(null);
            }
        })
    }

    const saveTask = async () => {
        const currentUserId = localStorage.getItem("user_id");
        const taskinfo = {
            ...newTask,
            reference: task_reference_id,
            tree_node_id_ref: task_tree_node_id_ref,
            created_on: new Date().toISOString(),
            owned_by: newTask.owned_by || currentUserId
        }

        taskinfo.progress = validNumber(taskinfo.progress);
        taskinfo.remind = validNumber(taskinfo.remind);
        taskinfo.escalate = validNumber(taskinfo.escalate);
        
        if (!validateTask(taskinfo)) return;

        if (isTerminalTaskStatus(newTask?.status)) {
            setPendingConfirm({ action: proceedWithSave, status: newTask.status });
            return;
        }
        await proceedWithSave();
    }

    const proceedWithUpdate = async () => {
        const task = {
            ...editTask,
            remind: validNumber(editTask.remind),
            escalate: validNumber(editTask.escalate),
            progress: validNumber(editTask.progress),
        }
        await handleUpdateTask({
            editTask:task,
            previusTaskInfo,
            reassign_persmision,
            users,
            dispatch,
            snackbar,
            onSuccess: async () => {
                await dispatch(fetchtAllTasks({ searchQuery: localStorage.taskTableSearchQuery, action_item_id: action_item_id }));
                setPendingConfirm(null);
            },
            setEditTask
        });
    }

    const updateTaskInfo = async () => {
        const newStatus = editTask?.status;
        const previousStatus = previusTaskInfo?.status;

        if (newStatus !== previousStatus && isTerminalTaskStatus(newStatus) && !isTerminalTaskStatus(previousStatus)) {
            setPendingConfirm({ action: proceedWithUpdate, status: editTask.status });
            return;
        }

        await proceedWithUpdate();
    }


    const delTask = async (task_id, task_name) => {
        await handleDeleteTask({
            task_id,
            task_name,
            dispatch,
            snackbar,
            onSuccess: async () => {
                await dispatch(fetchtAllTasks({ searchQuery: localStorage.taskTableSearchQuery }));
            },
            setEditTask
        });
    }

    const handleExportCSV = () => {
        dispatch(exportCSV()).then((res) => {
            if (exportCSV.fulfilled.match(res)) {
                snackbar("Tasks exported successfully.", "success");
            } else {
                snackbar("Error exporting CSV: " + res.payload, "error");
            }
        });
    };

    // Determine loading message based on current operation
    const getLoadingMessage = () => {
        if (newTask) return "Adding task...";
        if (editTask) return "Updating task...";
        return "Loading...";
    };

    const allTasks = Array.isArray(tasks) ? tasks : [tasks];
    const openingFromActionItems = !!action_item_id;
    let columnsData = !useTableInAuditTrail ? columns : columns.map(d => ({ ...d, sort: false })).filter(a => a.field !== "action")
    if(openingFromActionItems){
        columnsData = columns.map(d => ({ ...d, sort: false }))
    }
    return <>
        {/* {loading && <Loader text={getLoadingMessage()} />} */}
        <AppTable
            ref={tableContainerRef}
            columnsData={columnsData}
            showSearchInput={!useTableInAuditTrail ? true : false}
            disableSearchFilters={openingFromActionItems}
            usingInPopup={true}
            contentBeforeSearchFilter={<TaskCustomFilter
                isDropdownOpen={isDropdownOpen}
                setIsDropdownOpen={setIsDropdownOpen}
                filterType={filterType}
                setFilterType={setFilterType}
                disableFilter={openingFromActionItems}
            />}
            paginate={useTableInAuditTrail ? false : true}
            pagination={{
                limit: [limit, setLimit],
                offset: [offset, setOffset],
                pagination,
                maxVsbleButtons: 7,
                justifyContent: "center",
                paginationPosition: {
                    position: "center",
                    leftContent: <AddBtn
                        onClick={() => {
                            if (editTask !== null || newTask !== null) {
                                snackbar(
                                    "Please save or cancel the current row before adding or editing another one.",
                                    "error"
                                );
                                return;
                            }
                            scrollToTop(tableContainerRef);
                            handleSetNewTask({})
                        }}
                        title={"Add new task"}
                        disabled={openingFromActionItems || editTask !== null || newTask !== null}
                    />,
                    rightContent: <ExportCsvBtn handleExportCSV={handleExportCSV} />
                },
                paginationShadow: true,
            }}
            onFilterSortHandler={setSearchQuery}

        >
            {!useTableInAuditTrail && (
                <>
                    {
                        newTask && <AddEditRow
                            taskInfo={taskInfo}
                            handleAddEditRow={saveTask}
                            inputState={handleSetNewTask}
                            action="add"
                            reference={task_reference}
                            closePopup={closePopup}
                            reassign_persmision={reassign_persmision}
                            loading={loading}
                        />
                    }
                    {
                        allTasks.map(t => {
                            let key = t.task_id
                            return editTask && editTask.task_id === t.task_id ?
                                <AddEditRow
                                    taskInfo={t}
                                    handleAddEditRow={updateTaskInfo}
                                    inputState={setEditTask}
                                    action="edit"
                                    key={key}
                                    reference={task_reference}
                                    closePopup={closePopup}
                                    setPreviusTaskInfo={setPreviusTaskInfo}
                                    reassign_persmision={reassign_persmision}
                                    loading={loading}
                                />
                                : <AddEditRow
                                    taskInfo={t}
                                    inputState={setEditTask}
                                    delTask={delTask}
                                    setPreviusTaskInfo={setPreviusTaskInfo}
                                    key={key}
                                    reference={task_reference}
                                    closePopup={closePopup}
                                    reassign_persmision={reassign_persmision}
                                    isAnyOperationActive={!!newTask || !!editTask}
                                />
                        })
                    }
                </>
            )}
            {useTableInAuditTrail && <>{auditTrailRow}</>}
        </AppTable>
        {pendingConfirm && (
            <TaskUpdateConfirm
                closeModal={() => setPendingConfirm(null)}
                onSave={pendingConfirm.action}
                status={pendingConfirm.status}
            />
        )}


    </>
}

export default TaskTable